<div 
  class="d-flex editor-modal-header"
  [ngClass]="{'align-items-center justify-content-end p-3': ingredientChoicesType !== ingredientChoicesTypeEnum.Steps, 'align-items-center justify-content-between padded-right-20 padded-left-20': ingredientChoicesType === ingredientChoicesTypeEnum.Steps}"
>
  <div class='steps-wrapper-in-modal' [ngClass]="{'full-width': !isTablet, 'width-90': isTablet}" *ngIf="!isMobile && ingredientChoicesType === ingredientChoicesTypeEnum.Steps && inItemEditorModal">
    <div class='steps-ingredient-choices-in-modal primary-border-color fw-600' #scrollLinksWrapper *ngIf="(!orderableItem.choiceGroups || !orderableItem.choiceGroups.length)">
      <div class="primary-text-color gray-border-color"></div>
      <div *ngFor="let choice of choices | filterOutInstruction; trackBy: trackByChoiceFn;"
           #scrollLink
           [tabindex]="!!(choice | canMoveToStepChoice : (choices | filterOutInstruction) : visibleChoice : item) ? 0 : -1"
           [attr.aria-disabled]="!(choice | canMoveToStepChoice : (choices | filterOutInstruction) : visibleChoice : item)"
           role="button"
           (keypress.enter)="selectChoice(choice, $event)"
           (keypress.space)="selectChoice(choice, $event)"
           [attr.aria-pressed]="((choices | filterOutInstruction) | choiceIndex : choice) === ((choices | filterOutInstruction) | choiceIndex : visibleChoice)"
           (click)="selectChoice(choice, $event)"
           class="primary-text-color gray-border-color cursor-pointer"
           [ngClass]="{'selection-bg-color selection-inverse-text-color selection-border-color active':
                        ((choices | filterOutInstruction) | choiceIndex : choice) === ((choices | filterOutInstruction) | choiceIndex : visibleChoice),
           'default-cursor': !(choice | canMoveToStepChoice : (choices | filterOutInstruction) : visibleChoice : item) && !(item | valid)}">
         <span>{{choice.name}}</span>
      </div>
    </div>

    <div class='steps-ingredient-choices-in-modal primary-border-color fw-600' #scrollLinksWrapper *ngIf="orderableItem?.choiceGroups?.length">
      <div class="primary-text-color gray-border-color"></div>
      <div *ngIf='(item | invalidChoiceGroup : filteredGroups[0])'
          class='selection-bg-color selection-inverse-text-color selection-border-color active'>
      </div>
      <div *ngFor="let choiceGroup of filteredGroups; trackBy: trackByChoiceGroupFn;"
            #scrollLink
            [tabindex]="(choiceGroup | canMoveToStepGroup : item : selectedChoiceGroup : choiceGroups) ? 0 : -1"
            [attr.aria-disabled]="!(choiceGroup | canMoveToStepGroup : item : selectedChoiceGroup : choiceGroups)"
            role="button"
            (keypress.enter)="onChoiceGroupChange(choiceGroup, $event)"
            (keypress.space)="onChoiceGroupChange(choiceGroup, $event)"
            [attr.aria-pressed]="((choiceGroup | groupIndex : choiceGroups) === (selectedChoiceGroup | groupIndex : choiceGroups)) &&
              (selectedChoice?.name !== choices[0]?.name || ((selectedChoiceGroup | groupIndex : choiceGroups) !== 0 || ((item | orderedChoice : choices[0]?.name) | valid)))"
            (click)='onChoiceGroupChange(choiceGroup, $event)'
            class="primary-text-color gray-border-color cursor-pointer"
            [ngClass]="{'selection-bg-color selection-inverse-text-color selection-border-color active':
              ((choiceGroup | groupIndex : choiceGroups) === (selectedChoiceGroup | groupIndex : choiceGroups)) &&
              (selectedChoice?.name !== choices[0]?.name || ((selectedChoiceGroup | groupIndex : choiceGroups) !== 0 || ((item | orderedChoice : choices[0]?.name) | valid))),
            'default-cursor': !(choiceGroup | canMoveToStepGroup : item : selectedChoiceGroup : choiceGroups) && !(item | valid)}">
          <span>{{choiceGroup?.name}}</span>
      </div>
    </div>

    <button
      ftsAuditableButton
      *ngIf='isItemValid'
      ftsAsyncButton [subscription]='submitLoadingSubscription'
      class='btn action-bg-color action-inverse-text-color action-btn font-secondary submit-btn text-uppercase text-nowrap'
      (click)='onSubmitBtnClick()'>
      {{submitBtnLabel}}
    </button>
  </div>
  <div>
    <button class='close' (click)='handleCancel()' ftsAuditableButton auditName="Close" [attr.aria-label]="'component.item_editor_modal.item_editor_modal_header.close' | translate">
      <span aria-hidden='true'>&times;</span>
    </button>
  </div>
</div>